import * as React from "react";

const VideoPlay: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="168" height="168" viewBox="0 0 168 168" fill="none">
            <g id="Group 3407" filter="url(#filter0_d_293_45161)">
                <circle id="Ellipse 444" cx="84" cy="76" r="68" fill="black" fill-opacity="0.5"/>
                <path id="Polygon 5" d="M106.75 77.625L71 102L71 53.25L106.75 77.625Z" fill="white"/>
            </g>
            <defs>
                <filter id="filter0_d_293_45161" x="0" y="0" width="168" height="168" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="8"/>
                    <feGaussianBlur stdDeviation="8"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_293_45161"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_293_45161" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
};

export default React.memo(VideoPlay);
